import React, { useContext } from 'react';
import { T as Typography } from './Typography-BUVIUAC9.js';
import { a as ComboboxContext } from './ComboboxProvider-DdsdhWRT.js';

var styles = {"actionContainer":"Ow9wSNnGP-g-","actionButton":"ncp0nKHQ7d8-"};

function ComboboxAction(props) {
    const { searchValue } = useContext(ComboboxContext);
    if (props.visible) {
        const isVisible = typeof props.visible === "function" && !props.visible({ searchValue });
        if (isVisible || !props.visible) {
            return null;
        }
    }
    const options = { searchValue };
    const computedLabel = typeof props.label === "string" ? props.label : props.label(options);
    return (React.createElement("div", { className: styles.actionContainer },
        React.createElement("button", { className: styles.actionButton, onClick: e => props.onClick(e, options), type: "button" },
            React.createElement(Typography, { element: "span", size: "base", textColor: "green", fontWeight: "semiBold" }, computedLabel))));
}

export { ComboboxAction as C };
